import type { ChatThread } from '../../services/data.store';

/**
 * Whose conversation this is, for the byline in the tenant-wide chat list.
 *
 * Only meaningful there: in "Your Chats" every row is the caller's, so the
 * byline would be noise. Kept out of the component so the cases — an agent run
 * with no creator, an embedded end-user who isn't a tenant user, a creator who
 * has since left the tenant — are testable without rendering anything.
 *
 * `userNames` maps a tenant user's id to their display name, and comes from the
 * Admin-only /tenant-config/users list.
 */
export function chatThreadOwnerLabel(
  thread: Pick<ChatThread, 'created_by'>,
  currentUserId: string | undefined,
  userNames: Map<string, string>,
): string {
  const createdBy = thread.created_by;
  // Agent-initiated threads have no creator at all.
  if (!createdBy) return 'Agent';
  if (createdBy === currentUserId) return 'You';
  // "embed:<sub_id>" is an embedded end-user, not a member of the tenant, so
  // there's no user record to name them by.
  if (createdBy.startsWith('embed:')) return 'Embedded chat';
  // A creator missing from the tenant list has usually been removed from it.
  return userNames.get(createdBy) || 'Unknown user';
}
